// BANNER
export const TITLE = <div>Professional Certification Bootcamp</div>;
export const SUB_TITLE = "Get Dynatrace Professional Certified faster with comprehensive bootcamp sessions delivered remotely by a Dynatrace expert.";
export const TRAINING_TYPE = "PROFESSIONAL";

// INSTRUCTIONS
const step1: {step: String,title: String,subTitle: String} = {step: "STEP 1", title: "Register", subTitle: "Register for an upcoming Professional Certification bootcamp."}
const step2: {step: String,title: String,subTitle: String} = {step: "STEP 2", title: "Attend", subTitle: "Attend the bootcamp in full and complete all labs and quizzes."}
const step3: {step: String,title: String,subTitle: String} = {step: "STEP 3", title: "Schedule exam", subTitle: "Schedule and pass your written certification exam"}
const step4: {step: String,title: String,subTitle: String} = {step: "STEP 4", title: "Schedule exam", subTitle: "Schedule and pass your practical certification exam"}
export const ALL_STEPS: {step: String,title: String,subTitle: String}[] = [step1, step2, step3, step4];

//CALENDAR
export const CALENDAR_SUB_TITLE = "Check the following schedule to register and join the upcoming live sessions for Professional" +
                                    " Certification Bootcamp on your most convenient time.";

// Requirements
export const TITLE_NOTES_1 = "Requirements"
export const BODY_NOTES_1 = <div className="ml-2 mt-3">
                                ·&nbsp;&nbsp; This training is for technical resources that want to power up their Dynatrace skills and knowledge.
                                <br></br>
                                <br></br>
                                ·&nbsp;&nbsp; An active Associate Certification is required to register for this training.
                                <br></br>
                                <br></br>
                                ·&nbsp;&nbsp; An up-to-date broswer.
                            </div>;


// Certifications & Achievements
export const TITLE_NOTES = "Certifications & Achievements"
export const BODY_NOTES = <div className="ml-2 mt-3">
                                ·&nbsp;&nbsp; Upon completion of this training, you’ll be ready to take and pass the Professional Certification exam.
                                <br></br>
                                <br></br>
                                ·&nbsp;&nbsp; Becoming a Dynatrace Certified Professional allows you to:
                                <br></br>
                                &nbsp;&nbsp;·&nbsp;&nbsp; Validate your Dynatrace knowledge to peers, customers, and competitors
                                <br></br>
                                &nbsp;&nbsp;·&nbsp;&nbsp; Move up in your career path with the certification of an industry leader
                                <br></br>
                                &nbsp;&nbsp;·&nbsp;&nbsp; Get invited to the Partner Pro Club which gives you access to exclusive free training and resources
                                <br></br>
                                <br></br>
                                ·&nbsp;&nbsp; Dynatrace Professional Certification supersedes Dynatrace Associate Certification, remains valid for 2 years, it can be renewed.
                            </div>;


// FAQs
export const TITLE_ONE = "Access the Demo environment";
export const TITLE_TWO = "Webinars";

export const SUB_TITLE_ONE = <div>Access the <a target="_blank" href="https://demo.live.dynatrace.com/">Demo environment</a>, where you can practice your skills</div>;
export const SUB_TITLE_TWO = <div>Get in touch with our experts to get most out of the Dynatrace software intelligence platform: <a target="_blank" href="https://www.dynatrace.com/news/webinar/">Dynatrace webinars.</a></div>;

// --



